import { auto_complete_map } from "@/components/Delivery/delivery_helpers";

export default {
  name: "CatalogueView",
  props: {
    vm: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "vm.is_dropin_selected": {
      immediate: true,
      handler(isDropInSelected) {
        if (this.vm && isDropInSelected) {
          this.$nextTick(this.initAddItemLocationAutocomplete);
        }
      },
    },
    "vm.isEditing"(isEditing) {
      if (this.vm && isEditing) {
        this.$nextTick(this.init_edit_item_location_autocomplete);
      }
    },
    "vm.update_item_form.service_type_id"() {
      if (this.vm?.isEditing) {
        this.$nextTick(this.init_edit_item_location_autocomplete);
      }
    },
  },
  mounted() {
    this.addItemModal = this.$refs.addItemModal;
    this.manageProductModal = this.$refs.manageProductModal;

    if (this.addItemModal) {
      this.addItemModal.addEventListener("shown.bs.modal", this.handleAddItemModalShown);
    }

    if (this.manageProductModal) {
      this.manageProductModal.addEventListener("shown.bs.modal", this.handle_manage_product_modal_shown);
    }
  },
  beforeUnmount() {
    if (this.addItemModal) {
      this.addItemModal.removeEventListener("shown.bs.modal", this.handleAddItemModalShown);
    }

    if (this.manageProductModal) {
      this.manageProductModal.removeEventListener("shown.bs.modal", this.handle_manage_product_modal_shown);
    }
  },
  methods: {
    handleAddItemModalShown() {
      if (!this.vm) return;
      this.vm.fetch_categories();
      this.initAddItemLocationAutocomplete();
    },
    handle_manage_product_modal_shown() {
      this.init_edit_item_location_autocomplete();
    },
    initAddItemLocationAutocomplete() {
      const locationInput = this.$refs.addItemLocationInput;

      if (!this.vm?.is_dropin_selected || !locationInput) {
        return;
      }

      auto_complete_map(locationInput, (address) => {
        this.vm.item_form.service_location = address;
        if (this.vm.errors) {
          this.vm.errors.service_location = null;
        }
      }).catch((error) => {
        console.error("Failed to load Google address suggestions:", error);
      });
    },
    init_edit_item_location_autocomplete() {
      const locationInput = this.$refs.editItemLocationInput;

      if (!this.vm?.isEditing || !locationInput) {
        return;
      }

      auto_complete_map(locationInput, (address) => {
        this.vm.update_item_form.location = address;
      }).catch((error) => {
        console.error("Failed to load Google address suggestions:", error);
      });
    },
    resetProductForm() {
      if (!this.vm) return;
      this.vm.reset_product_form();
      this.resetFileInputs();
    },
    resetFileInputs() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
      if (this.$refs.editFileInput) {
        this.$refs.editFileInput.value = null;
      }
    },
    clickFileInput() {
      this.$refs.fileInput?.click();
    },
    clickEditFileInput() {
      this.$refs.editFileInput?.click();
    },
    is_product_pricing_preview_visible(price) {
      return this.vm?.modalType === "product"
        && Number(price) >= 0;
    },
    calculate_customer_product_price(price) {
      const basePrice = Number(price);
      if (!Number.isFinite(basePrice) || basePrice < 0) return 0;

      return Math.ceil(((basePrice + 2) / (1 - 0.055)) * 100) / 100;
    },
    calculate_product_fee(price) {
      const basePrice = Number(price);
      if (!Number.isFinite(basePrice) || basePrice < 0) return 0;

      return Math.max(0, this.calculate_customer_product_price(basePrice) - basePrice);
    },
    format_price(value) {
      if (this.vm?.format_price) {
        return this.vm.format_price(value);
      }

      return Number(value || 0).toLocaleString("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatAttributeOptionValue(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
    },
  },
};

function append_if_present(form_data, key, value) {
  if (value !== undefined && value !== null && value !== "") {
    form_data.append(key, value);
  }
}

function append_media_files(form_data, files = []) {
  files.forEach((file) => {
    form_data.append("media_files", file);
  });
}

function build_create_item_form_data({
  item_form,
  base_profile_id,
  organization_id,
  product_type_id,
  selected_subcategory,
  upload_files,
  should_publish = false,
}) {
  const form_data = new FormData();

  form_data.append("name", item_form.name);
  form_data.append("price", item_form.price);
  form_data.append("description", item_form.description || "");
  form_data.append("base_profile", base_profile_id);
  form_data.append("product_type_id", product_type_id);
  form_data.append("category_id", selected_subcategory || "");
  form_data.append("attributes", JSON.stringify(item_form.attributes || {}));
  form_data.append("is_published", should_publish ? "true" : "false");

  append_if_present(form_data, "organization_id", organization_id);
  append_if_present(form_data, "service_type_id", item_form.service_type_id);
  append_if_present(form_data, "location", item_form.service_location);
  append_media_files(form_data, upload_files);

  return form_data;
}

function build_update_item_form_data({
  update_item_form,
  base_profile_id,
  upload_files,
  previews,
}) {
  const form_data = new FormData();

  form_data.append("product_id", update_item_form.product_id);
  form_data.append("name", update_item_form.name);
  form_data.append("price", update_item_form.price);
  form_data.append("description", update_item_form.description || "");
  form_data.append("base_profile_id", base_profile_id);
  form_data.append("category_id", update_item_form.subcategory_id || "");
  form_data.append("attributes", JSON.stringify(update_item_form.attributes || {}));

  append_if_present(form_data, "service_type_id", update_item_form.service_type_id);
  append_if_present(form_data, "location", update_item_form.location);
  append_media_files(form_data, upload_files);

  previews
    .filter((preview) => preview._delete && preview.id)
    .map((preview) => preview.id)
    .forEach((id) => form_data.append("delete_image_ids", id));

  return form_data;
}

function submit_catalogue_item({ endpoint, form_data, token }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/${endpoint}/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: form_data,
      processData: false,
      contentType: false,
      success: resolve,
      error: reject,
    });
  });
}

export function create_catalogue_item(options) {
  const form_data = build_create_item_form_data(options);

  return submit_catalogue_item({
    endpoint: "create_product",
    form_data,
    token: options.token,
  });
}

export function update_catalogue_item(options) {
  const form_data = build_update_item_form_data(options);

  return submit_catalogue_item({
    endpoint: "update_product",
    form_data,
    token: options.token,
  });
}
